import styled from "styled-components";
import { ModalVerticalOverflowWrapper } from "../../../../components/Modal/styled";

export const DeactivateCampaignModalWrapper = styled.div`
  ${ModalVerticalOverflowWrapper} {
    padding-bottom: 0 !important;
  }
`;
